/* --------------------------------------------------------------------

FUNCTIONS

-------------------------------------------------------------------- */

const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");

function showItem(item) {
	item.classList.remove('hidden')
}

function hideItem(item) {
	item.classList.add('hidden')
}

function setRequiredFields() {
	let allRequired = [];
	let requiredInputs = form.querySelectorAll('input');
    requiredInputs.forEach(input => {
        if (input.required) {
            allRequired.push(input)
        }
    })
    let requiredSelects = form.querySelectorAll('select');
    requiredSelects.forEach(select => {
        if (select.required) {
            allRequired.push(select)
        }
    })
    return allRequired
}

function checkFormReady() {
	let formReady = true;
    for (let i = 0; i < requiredFields.length; i++) {
        if (!requiredFields[i].value || !requiredFields[i].checkValidity()) {
            formReady = false
            break
        }
    }
    return formReady
}

function validateForm() {
	let ready = checkFormReady();
    if (ready) {
        submitButton.disabled = false;
    } else {
        submitButton.disabled = true;
    }
}

function checkListValue(input) {
    let list = input.list;
    if (list) {
        let options = list.options;
        for (let i = 0; i < options.length; i++) {
            if (input.value === options[i].value) {
                return true
            }
        }
        return false
    }
    return true
}

function displayMdPrompt() {
	document.getElementById('est_md_group').classList.remove('hidden');
    requireChildFields('est_md_group')
}

function hideMdPrompt() {
	let mdPromptGroup = document.getElementById('est_md_group');
    mdPromptGroup.classList.add('hidden');
    let inputs = mdPromptGroup.querySelectorAll('input');
    inputs.forEach(input => {
        input.required = false
    })
}

function showOtherInput() {
    document.getElementById('other_license_type').required = true;
    otherLicenseInput.classList.remove('hidden');
}

function hideOtherInput() {
    document.getElementById('other_license_type').required = false;
    otherLicenseInput.classList.add('hidden');
}

function checkMdType() {
    let isProAccount = proAccountTypes.includes(this.value);
    if (!isProAccount) {
        showMdFields()
    } else {
        if (this.value === 'Other') {
            showOtherInput();
        } else {
            hideOtherInput();
        }
        hideMdFields();
    } 
    if (this.value === 'Esthetician') {
        displayMdPrompt();
    } else {
        hideMdPrompt();
    }
}

function clearChildFields(parentId) {
	let parent = document.getElementById(parentId);
    let inputs = parent.querySelectorAll('input');
    inputs.forEach(input => {
        input.required = false
        if (input.value) {
            input.value = null
        }
        if (input.checked) {
            input.checked = false
        }
    })
    removeRequiredFieldsListener();
    setRequiredFieldsListener();
    validateForm();
}

function requireChildFields(parentId) {
	let parent = document.getElementById(parentId);
    let inputs = parent.querySelectorAll('input');
    inputs.forEach(input => {
        input.required = true
    })
    removeRequiredFieldsListener();
    setRequiredFieldsListener();
    toggleLicenseUploadRequirement();
}

function showMdFields() {
    hideOtherInput();
    mdActive = true;
	mdFieldGroup.classList.remove('hidden');
    requireChildFields(mdFieldGroup.id)
}

function hideMdFields() {
	mdFieldGroup.classList.add('hidden');
    clearChildFields(mdFieldGroup.id)
    mdActive = false
}
  
function checkMdCondition() {
	if (this.value === 'true') {
  	showMdFields();
  } else {
  	hideMdFields();
  }
}

function removeListInputListeners() {
    listInputs.forEach(input => {
        input.removeEventListener('change', function(){})
    })
}

function setListInputListeners() {
    listInputs.forEach(input => {
        input.addEventListener('change', function() {
            if (input.value) {
                let valid = checkListValue(this);
                if (!valid) {
                    input.value = ''
                }
            }
        })
    })
}

function getListInputs() {
	let listInputs = [];
    let textInputs = form.querySelectorAll('input[type="text"]');
    for (let i = 0; i < textInputs.length; i++) {
        if (textInputs[i].list) {
            let listSize = textInputs[i].list.options.length
            if (listSize > 0){
                listInputs.push(textInputs[i])
            }
        }
    }
    return listInputs
}

function toggleLicenseUploadRequirement() {
    let country = countryInput.value;
    if (country !== 'Canada') {
        if (mdActive) {
            licenseUploadInput.required = true
            licenseUploadLabel.textContent = "Medical License*"
        }
    } else {
        licenseUploadInput.required = false
        licenseUploadLabel.textContent = "Medical License"
    }
    removeRequiredFieldsListener();
    setRequiredFieldsListener();
    validateForm()
}

function updateStateOptions() {
	stateInput.required = false
	stateInput.value = null;
    let datalist = document.getElementById('state-options');
    let dataOptions = datalist.querySelectorAll('option');
    dataOptions.forEach(state => {
        state.remove();
    })
    let key = this.value.toLowerCase().replaceAll(' ', '_');
    let stateList = stateLists[key];
    if (stateList) {
        for (let i = 0; i < stateLists[key].length; i++) {
            let dataOption = document.createElement('option');
            dataOption.value = stateLists[key][i];
            dataOption.innerHTML = stateLists[key][i];
            datalist.appendChild(dataOption)
        }
        stateInput.required = true
    }
    removeListInputListeners();
    listInputs = getListInputs();
    setListInputListeners();
    removeRequiredFieldsListener();
    setRequiredFieldsListener();
}

function removeRequiredFieldsListener() {
    requiredFields.forEach(field => {
        field.removeEventListener('change', validateForm)
    });
}

function setRequiredFieldsListener() {
    requiredFields = setRequiredFields()
    requiredFields.forEach(field => {
        field.addEventListener('change', validateForm)
    });
}

// Called with HTML
function selectStyles(el) {
    if (el.value) {
        el.classList.add('value-added');
    } else {
        el.classList.remove('value-added');
    }
}

/* --------------------------------------------------------------------

VARIABLES

-------------------------------------------------------------------- */

let form = document.getElementById('provider-application');
let requiredFields;
let phoneInput = form.querySelector('input[type="tel"]');
let emailInput = form.querySelector('input[type="email"]');
let licenseInput = form.querySelector('select[name="license_type"]');
let licenseUploadInput = form.querySelector('input[type="file"][name="medical_license__file_"]')
let licenseUploadLabel = form.querySelector('label[for="medical_license__file_"]');
let radioConditionals = document.querySelectorAll('input[type="radio"][name="do_you_work_inside_of_a_medical_practice_"]');
let submitButton = form.querySelector('[type="submit"]');
let mdFieldGroup = document.getElementById("md-details");
let otherLicenseInput = document.getElementById("other_option_group");
let listInputs = getListInputs();
let countryInput = document.getElementById('country');
let stateInput = document.getElementById('state');
let statusBox = document.getElementById('form-status');
let mdActive = false;

let proAccountTypes = [
	"Esthetician",
    "Registered Nurse",
    "Cosmetologist",
    "Other"
]

let stateLists = {
  united_states: ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Minor Outlying Islands', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'U.S. Virgin Islands', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
  canada: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Northwest Territories', 'Nunavut', 'Yukon']
}


/* --------------------------------------------------------------------

LISTENERS

-------------------------------------------------------------------- */

setRequiredFieldsListener();

phoneInput.addEventListener('beforeinput', function() {
	if (!event.inputType.includes('delete')) {
        let pattern = new RegExp(this.pattern)
        if (!pattern.test(event.data)) {
            event.preventDefault();
        }
    }
})

licenseInput.addEventListener('change', checkMdType);

radioConditionals.forEach(option => {
	option.addEventListener('change', checkMdCondition)
})

setListInputListeners();

countryInput.addEventListener('change', updateStateOptions);
countryInput.addEventListener('change', toggleLicenseUploadRequirement);


/* SUBMIT THE FORM */

function formSuccess(body) {
	console.log('success')
	submitButton.disabled = false
    form.classList.add('hidden')
    statusBox.textContent = 'Thank you for your interest. One of our representatives will review your application and be in touch.'
    statusBox.classList.add('status-success')
}

function formFail(body) {
	console.log('failed')
	submitButton.disabled = false
    form.classList.add('hidden')
    statusBox.textContent = 'There was an issue submitting your application. Please refresh this page and try again.'
    statusBox.classList.add('status-success')
}

/* submitButton.addEventListener('click', function() {
  form.submit();
}) */

submitButton.addEventListener('click', async function(event) {
  event.preventDefault();
  submitButton.disabled = true

  let formData = new FormData(form);
  formData.append('pageUri', window.location.href)
  formData.append('pageName', document.title)
  let params = {
    method: 'POST',
    body: formData
  }
  
  let endpoint = 'https://enlt6vc6nnucdub.m.pipedream.net';

  await fetch(endpoint, params)
    .then(response => formSuccess(response))
    .catch(error => formFail(error));

});
  